import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { CfgIntegracaoEvento } from '../../../model/cfg-integracao-evento.model';


@Injectable({
  providedIn: 'root'
})
export class CfgIntegracaoEventoService extends DefaultService<CfgIntegracaoEvento> {
  static URL = '/api/cfgintegracao/cfgintegracaoevento/v1/cfgintegracaoevento';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService,
  ) {
    super(
      httpClient,
      errorHandlerService,
      CfgIntegracaoEventoService.URL
    );
  }

}
